/**
 * ポートフォリオ起動直後の同期処理をまとめる。
 * 最終利用日時更新、DB 同期、初期コメント候補投入、リモート反映を順に扱う。
 */

import type { PortfolioPageData } from '@/types'
import { syncDbFileToRemote } from '../syncDbFileToRemote'
import { updateLastUsedAt } from '../updateLastUsedAt'
import { ensureDefaultCommentCandidates } from './ensureDefaultCommentCandidates'
import { syncDatabase } from './syncDatabase'

/**
 * ポートフォリオ起動後に必要な同期処理を実行する。
 * @param params 認証情報と DB 読み書き関数を含むポートフォリオ情報を受け取る。
 * @returns 値は返さない。
 */
export const syncAfterSetup = async (
  params: PortfolioPageData & {
    getToken: () => Promise<string | null>
  },
): Promise<void> => {
  const { readonly, getToken, readFromDatabase, writeToDatabase } = params

  // writable の場合の処理
  if (writeToDatabase !== undefined && !readonly) {
    await Promise.all([
      // lastUsed 更新
      updateLastUsedAt({ portfolio: params, getToken }),
      // DB 同期
      (async () => {
        // 既定コメント候補追加
        await ensureDefaultCommentCandidates({
          readFromDatabase,
          writeToDatabase,
        })
        // DB に最新情報を同期
        await syncDatabase({
          readFromDatabase,
          writeToDatabase,
        })
        // local > remote の場合に DB File を remote にアップロード
        await syncDbFileToRemote({ portfolio: params, getToken })
      })(),
    ])
  }
}
